import { render, staticRenderFns } from "./sentenceM13.vue?vue&type=template&id=59ffcf75&scoped=true&"
import script from "./sentenceM13.vue?vue&type=script&lang=js&"
export * from "./sentenceM13.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM13.vue?vue&type=style&index=0&id=59ffcf75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ffcf75",
  null
  
)

export default component.exports